import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useCallback } from 'react';
import { type ContextItemFileType, ContextItemType } from 'src/@types/ai';
import Iconify from 'src/components/iconify';
// import { NavRecentItemIcon } from 'src/layouts/DashboardLayout/NavRecents/NavRecentItemIcon';
import { useLocales } from 'src/locales';
// import { useDocContentContext } from 'src/pages/dashboard/DocsPage/DocContent/DocContentContext';
import { useFileUploadContext } from 'src/provider/FileUploadContext';
import { AIInputStateControl } from '../useAIInputState';

type Props = {
  control: AIInputStateControl;
};

export const AIContextUpload = ({ control }: Props) => {
  const { translate } = useLocales();
  const { toggleContextFiles } = control((s) => ({
    toggleContextFiles: s.toggleContextFiles,
  }));
  const { control: uploader } = useFileUploadContext();

  const handleFileSelect = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      event.stopPropagation();
      const file = event.target.files?.[0];
      if (!file) return;
      const contextFileType = file.type.startsWith('image')
        ? ContextItemType.IMAGE
        : ContextItemType.FILE;
      selectContextFile(file, contextFileType);
    },
    [],
  );

  const handleClickAttachFile = useCallback(
    (e: React.MouseEvent, mimeType: string) => {
      e.stopPropagation();
      const input = document.createElement('input');
      input.type = 'file';
      input.style.display = 'none';
      input.accept = mimeType;
      input.onchange = (e) => handleFileSelect(e as any);
      document.body.appendChild(input);
      input.click();
      input.remove();
    },
    [handleFileSelect],
  );

  const selectContextFile = async (file: File, type: ContextItemType) => {
    const [{ url }] = await uploader.uploadSingleFile(file);
    toggleContextFiles(type, { _id: url, media: file } as ContextItemFileType);
  };

  return (
    <>
      <MenuItem onClick={(e) => handleClickAttachFile(e, 'image/*')}>
        <ListItemIcon>
          <Iconify icon="tabler:photo" color="text.secondary" />
        </ListItemIcon>
        <ListItemText primary={translate('shared.labels.image')} />
        <Iconify icon="tabler:upload" color="text.secondary" />
      </MenuItem>
      <MenuItem
        onClick={(e) => handleClickAttachFile(e, 'application/pdf, text/*')}
      >
        <ListItemIcon>
          <Iconify icon="tabler:file-text" color="text.secondary" />
        </ListItemIcon>
        <ListItemText primary={translate('shared.labels.documents')} />
        <Iconify icon="tabler:upload" color="text.secondary" />
      </MenuItem>
    </>
  );
};
